<template>
  <div class="container">
    <div class="card">
      <div class="title"></div>

      <form @submit.prevent="submit">
        <div class="input">
          <label>Brugernavn</label>
          <input ref="uname" v-model="username" type="text" />
        </div>

        <br />

        <div class="input">
          <label>Password</label>
          <input ref="pword" v-model="password" type="password" />
        </div>

        <br />

        <div class="action">
          <button ref="btn" @click="login">Registrér</button>
        </div>
      </form>

      <div class="link"></div>
    </div>
  </div>
</template>

<script>
import router from "../../router";

export default {
  data() {
    return {
      username: null,
      password: null,
      error: "",
      returnUrl: "/igler",
    };
  },
  methods: {
    login() {
      if (!this.username) {
        this.$refs["uname"].placeholder = "Indtast brugernavn";
        return;
      }
      if (!this.password) {
        this.$refs["pword"].placeholder = "Indtast password";
        return;
      }

      this.$refs["uname"].disabled = true;
      this.$refs["pword"].disabled = true;
      this.$refs["btn"].disabled = true;

      var credentials = { username: this.username, password: this.password };

      this.$store
        .dispatch("auth/register", credentials)
        .then(() => router.push(this.returnUrl))
        .catch(() => {
          this.$refs["uname"].value = "";
          this.$refs["pword"].value = "";

          this.$refs["uname"].placeholder = "Brugernavn findes allerede";
          this.$refs["pword"].placeholder = "";

          this.$refs["uname"].disabled = false;
          this.$refs["pword"].disabled = false;
          this.$refs["btn"].disabled = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 30px;

  .card {
    width: 500px;
    height: 450px;
    background-color: #ffffff;
    box-shadow: 0 0 15px #999999;
    border-radius: 12px;
    padding: 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .input {
      display: flex;
      flex-direction: column;

      label {
        margin: 10px 0;
        font-weight: 600;
      }

      input {
        margin-bottom: 10px;
        padding: 10px 5px;
        font-size: 18px;

        &::placeholder {
          color: #d05366;
          opacity: 1;
          font-size: 18px;
          font-weight: 600;
        }
        &:-ms-input-placeholder {
          color: #d05366;
          opacity: 1;
          font-size: 18px;
          font-weight: 600;
        }
        &::-ms-input-placeholder {
          color: #d05366;
          opacity: 1;
          font-size: 18px;
          font-weight: 600;
        }
      }
    }

    .action {
      button {
        border: none;
        font-size: 18px;
        padding: 12px 25px;
        font-weight: 600;
        box-shadow: 0 0 5px #999999;
        color: #ffffff;
        cursor: pointer;
        background-color: #d05366;

        transition: box-shadow 0.2s;

        &:hover {
          box-shadow: 0 0 10px #333333;
        }
      }
    }

    .link {
      width: 100%;
      text-align: center;

      label {
        cursor: pointer;
      }
    }
  }
}

label {
  font-size: 18px;
}

@media only screen and (max-width: 600px) {
  .card {
    width: calc(100% - 15px);
    margin: 15px;
  }
}
</style>
